import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { StayComponent } from './stay/stay.component';
import { GroupBookingsComponent } from './group-bookings/group-bookings.component';
import { ExperiencesComponent } from './experiences/experiences.component';
import { ReachUsComponent } from './reach-us/reach-us.component';
import { FaqsComponent } from './faqs/faqs.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { AboutTatvaComponent } from './about-tatva/about-tatva.component';
import { HttpClientModule } from '@angular/common/http';
import { BookingsComponent } from './bookings/bookings.component';
import { TrekkingComponent } from './trekking/trekking.component';
import { FarmingComponent } from './farming/farming.component';
import { EatOutComponent } from './eat-out/eat-out.component';
import { DigitallyConnectedComponent } from './digitally-connected/digitally-connected.component';
import { StandardTentComponent } from './standard-tent/standard-tent.component';
import { ExecutiveRoomsComponent } from './executive-rooms/executive-rooms.component';
import { TariffComponent } from './tariff/tariff.component';
import { OtheractivitiesComponent } from './otheractivities/otheractivities.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GalleryComponent } from './gallery/gallery.component';
import { GalleryPropertyComponent } from './gallery-property/gallery-property.component';
import { GalleryNearbyplacesComponent } from './gallery-nearbyplaces/gallery-nearbyplaces.component';
import { ReservationComponent } from './reservation/reservation.component';
import { ProceedPaymentComponent } from './proceed-payment/proceed-payment.component';
import { PaymentsuccessComponent } from './paymentsuccess/paymentsuccess.component';
import { PaymentfailureComponent } from './paymentfailure/paymentfailure.component';



const appRoutes: Routes = [
  { path: '', component: HomeComponent, data: { title: 'Welcome to Tatva Hills' } },
  { path: 'tatva-stories', component: StayComponent, data: { title: 'Tatva Stories -Tatva Hills' } },
  { path: 'group-bookings', component: GroupBookingsComponent, data: { title: 'Group Bookings -Tatva Hills' } },
  { path: 'bookings', component: BookingsComponent, data: { title: 'Booking - Tatva Hills' } },

  { path: 'experiences', component: ExperiencesComponent, data: { title: 'Experiences -Tatva Hills' } },

  { path: 'about-tatva', component: AboutTatvaComponent, data: { title: 'About Tatva -Tatva Hills' } },
  { path: 'reach-us', component: ReachUsComponent, data: { title: 'Reach Us -Tatva Hills' } },
  { path: 'faqs', component: FaqsComponent, data: { title: 'FAQs -Tatva Hills' } },

  { path: 'standard-tent', component: StandardTentComponent, data: { title: 'Standard Tent -Tatva Hills' } },
  { path: 'executive-rooms', component: ExecutiveRoomsComponent, data: { title: 'Executive Rooms -Tatva Hills' } },
  { path: 'tariff', component: TariffComponent, data: { title: 'Tariff -Tatva Hills' } },

  { path: 'gallery', component: GalleryComponent, data: { title: 'Gallery -Tatva Hills' } },
  { path: 'farming', component: FarmingComponent, data: { title: 'Farming -Tatva Hills' } },
  { path: 'galleryproperty', component: GalleryPropertyComponent, data: { title: 'Property -Tatva Hills' } },
  { path: 'food', component: EatOutComponent, data: { title: 'Food -Tatva Hills' } },
  { path: 'digitally-connected', component: DigitallyConnectedComponent, data: { title: 'Digitally Connected Experiences -Tatva Hills' } },
  { path: 'activities', component: OtheractivitiesComponent, data: { title: 'Activities -Tatva Hills' } },
  { path: 'gallerynearbyplaces', component: GalleryNearbyplacesComponent, data: { title: 'Nearby Places -Tatva Hills' } },

  { path: 'terms-conditions', component: TermsConditionsComponent, data: { title: 'Terms Conditions -Tatva Hills' } },
  { path: 'privacy-policy', component: PrivacyPolicyComponent, data: { title: 'Privacy Policy -Tatva Hills' } },
  { path: 'reservation', component: ReservationComponent, data: { title: 'Reservation -Tatva Hills' } },
  { path: 'proceed-payment', component: ProceedPaymentComponent, data: { title: 'Proceed Payment -Tatva Hills' } },

  { path: 'payment-success', component: PaymentsuccessComponent, data: { title: 'Success Payment -Tatva Hills' } },

  { path: 'payment-failure', component: PaymentfailureComponent, data: { title: 'Failed Payment -Tatva Hills' } }

];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    StayComponent,
    GroupBookingsComponent,
    ExperiencesComponent,
    AboutTatvaComponent,
    ReachUsComponent,
    FaqsComponent,
    TermsConditionsComponent,
    PrivacyPolicyComponent,
    BookingsComponent,
    TrekkingComponent,
    FarmingComponent,
    EatOutComponent,
    DigitallyConnectedComponent,
    StandardTentComponent,
    ExecutiveRoomsComponent,
    TariffComponent,
    OtheractivitiesComponent,
    GalleryComponent,
    GalleryPropertyComponent,
    GalleryNearbyplacesComponent,
    ReservationComponent,
    ProceedPaymentComponent,
    PaymentsuccessComponent,
    PaymentfailureComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes),
    RecaptchaModule,  //this is the recaptcha main module
    RecaptchaFormsModule, //this is the module for form incase form validation 
    BrowserAnimationsModule,
  ],
   //exports: [RouterModule],
  providers: [Title],
  //providers: [Title,{provide : LocationStrategy , useClass: HashLocationStrategy}],
  bootstrap: [AppComponent]
})
export class AppModule { }
